import ComponentLayout from "../../../../src/layouts/component-layout";
import { Label, LabelColors, LabelSizes } from '@primer/react-brand';
import { StarIcon, CopilotIcon } from '@primer/octicons-react';
import { PropTableValues } from "../../../../src/components";
import * as React from 'react';
export default {
  ComponentLayout,
  Label,
  LabelColors,
  LabelSizes,
  StarIcon,
  CopilotIcon,
  PropTableValues,
  React
};